import { useCallback, useRef } from 'react';

/**
 * useSectionRefresh — what a credential section calls after a write.
 *
 * Re-reads the section's data (CredentialsPage's `onRefresh`) instead of
 * reloading the page, so the success toast stays on screen and an open drawer
 * shows the stored record. If the re-read fails, the page reloads — the write
 * itself already succeeded, and a stale view would be worse.
 *
 * @param {Function} [onRefresh] returns a promise
 * @returns {Function} stable async refresh
 */
export default function useSectionRefresh(onRefresh) {
	const ref = useRef(onRefresh);
	ref.current = onRefresh;
	return useCallback(async () => {
		try {
			if (!ref.current) throw new Error('No section refresh');
			await ref.current();
		} catch (_e) {
			window.location.reload();
		}
	}, []);
}
